import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'styles/pages/DigitalTools/TrackingSystem/TrackingSystem.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/DigitalTools/TrackingSystem/components/SectionHeader'));
const SectionExperience = dynamic(() => import('sections/DigitalTools/TrackingSystem/components/SectionExperience'));
const SectionApi = dynamic(() => import('sections/DigitalTools/TrackingSystem/components/SectionApi'));
const SectionIntegration = dynamic(() => import('sections/DigitalTools/TrackingSystem/components/SectionIntegration'));
const SectionCallToAction = dynamic(() => import('sections/DigitalTools/TrackingSystem/components/SectionCallToAction'));

export default function TrackingSystem(): ReactElement {
  return (
    <div className={cn('tracking-system')}>
      <SectionHeader/>
      <SectionExperience/>
      <SectionApi/>
      <SectionIntegration/>
      <SectionCallToAction/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Tracking System for Freight Forwarders | DF Alliance',
      description: "Stay updated with DF Alliance's advanced tracking system, offering real-time visibility and updates on your shipments for worry-free logistics management.",
      path: '/digital-tools/tracking-system',
    },
  };
};

TrackingSystem.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
